import { FormProvider, useForm } from 'react-hook-form';
import { Grid, Hidden, MenuItem, Tab, Typography } from '@material-ui/core';
import React, { useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';

import { CustomSelect } from '@uml/uml-components';
import Pagination from '@material-ui/lab/Pagination';
import ProcedureListItem from '../components/ProcedureListItem';
import ReactDOM from 'react-dom';
import Wrapper from '../components/Wrapper';
import api from '../utilities/api';

const useStyles = makeStyles((theme) => ({
  containerDiv: {
    maxWidth: 1130,
  },
  media: {
    height: 240,
    borderRadius: 4,
  },
  root: {
    position: 'relative',
    width: '100%',

    '&>div': {
      width: '100%',
    },
  },
  projectsList: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    marginTop: theme.spacing(2),
    '@media(min-width: 768px)': {
      gridTemplateColumns: '1fr 1fr',
      gap: 24,
    },
    '@media(min-width: 1200px)': {
      gridTemplateColumns: '1fr 1fr 1fr',
    },
  },
  projectsListItem: {
    position: 'relative',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    '@media(min-width: 768px)': {
      marginBottom: 0,
      paddingBottom: 50,
    },
  },
  projectListMedia: {
    height: 148,
    marginBottom: theme.spacing(2),

    '@media(min-width: 768px)': {
      height: 164,
    },
  },
  filterContainer: {
    '@media(min-width: 768px)': {
      maxWidth: '80%',
      display: 'inline-flex',
    },
  },
  filterForm: {
    '@media(min-width: 768px)': {
      display: 'flex',
    },
  },
  searchButton: {
    marginTop: 16,

    '@media(min-width: 768px)': {
      margin: 'auto',
    },
  },
  projectDetailButton: {
    '@media(min-width: 768px)': {
      position: 'absolute',
      bottom: 16,
      left: 16,
    },
  },
  projectsListItemTitle: {
    wordBreak: 'break-word',
    marginBottom: theme.spacing(2),
    '@media(min-width: 768px)': {
      height: 62,
    },
  },
  projectListDetail: {
    marginBottom: theme.spacing(2),
    fontSize: '1.3em',
  },
  statusLabel: {
    display: 'flex',
    alignItems: 'center',
  },
  statusLabelWrap: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
    height: 32,
  },
  projectItemDescription: {
    fontSize: '1.2em',
    marginBottom: theme.spacing(2),
  },
  projectsCount: {
    margin: '32px 0 16px 0',
  },
  pagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingTop: theme.spacing(2),
  },
}));

const AntTab = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.primary.contrastText,
    },
  },
  // eslint-disable-next-line react/jsx-props-no-spreading
}))((props) => <Tab disableRipple {...props} />);

const AntPagination = withStyles((theme) => ({
  root: {
    '& .MuiPaginationItem-page.Mui-selected': {
      backgroundColor: 'white !important',
      border: '1px solid #0069B4',
      color: theme.palette.action.active,
    },
  },
  // eslint-disable-next-line react/jsx-props-no-spreading
}))((props) => <Pagination {...props} />);

const ProcedureList = ({}) => {
  const classes = useStyles();
  const methods = useForm();
  const [procedures, setProcedures] = React.useState([]);
  const [count, setCount] = React.useState(0);
  const [pageCount, setPageCount] = React.useState(0);
  const [limit, setLimit] = React.useState(15);
  const [page, setPage] = React.useState(1);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await api.get(`/pp/procedures/external-search/`, {
          params: {
            limit,
            page,
            ordering: '-sorted_created',
          },
        });
        setProcedures(data.results);
        setCount(data.count);
      } catch (e) {
        console.error(e);
      }
    };
    fetchData();
  }, [limit, page]);

  useEffect(() => {
    const newPageCount = Math.ceil(parseInt(count, 10) / parseInt(limit, 10));
    setPageCount(newPageCount);
  }, [count, limit]);

  const handleLimit = (e) => {
    setLimit(e.target.value);
  };

  const handlePagination = (event, value) => {
    setPage(value);
  };

  return (
    <>
      <Grid container className={classes.containerDiv}>
        <Hidden mdDown>
          <Grid item xs={12} className={classes.projectsCount}>
            <Typography>Łącznie: {count} procedur</Typography>
          </Grid>
        </Hidden>
        <Grid item xs={12}>
          <Grid className={classes.projectsList}>
            {procedures.map((procedure) => {
              return (
                <ProcedureListItem key={procedure.id} procedure={procedure} />
              );
            })}
          </Grid>
        </Grid>
      </Grid>
      <Grid container style={{ justifyContent: 'space-betweend' }}>
        <Grid item xs={12} md={2}>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <FormProvider {...methods}>
            <form>
              <CustomSelect
                handleChange={(e) => handleLimit(e)}
                variant='standard'
                id='projectRange'
                label='Pokazuj'
                name='count_show_item'
                size='small'
              >
                {['15', '30', '60', '120'].map((item) => (
                  <MenuItem key={item} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </CustomSelect>
            </form>
          </FormProvider>
        </Grid>
        <Grid item xs={12} md={10} className={classes.pagination}>
          <AntPagination
            onChange={handlePagination}
            count={pageCount}
            variant='outlined'
            shape='rounded'
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ProcedureList;

ReactDOM.render(
  <Wrapper overrideService='pp' productionPrefix='prl' seed='procedure-list'>
    <ProcedureList />
  </Wrapper>,
  document.getElementById('procedure-list'),
);
